// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { REQUIRED } from 'errors'

const valueIsRequired = v => (
  (v === null || v === undefined || !v.length) && REQUIRED
)

export default valueIsRequired
